import React from 'react';
import { withFormsy } from 'formsy-react';

class Radio extends React.Component {
  render = () => {
    const {
      className,
      name,
      options,
      isValid,
      isPristine,
      placeholder,
      labelClassName = 'radio-label h3'
    } = this.props;
    const inputProps = {
      name,
      options,
      type: 'radio',
      onChange: this.handleChange
    };

    let classes = className ? `radio ${className}` : 'radio radio--small';
    classes += isValid || isPristine ? '' : ' simple-input--error';

    return (
      <div className={classes}>
        <label className={labelClassName} htmlFor={name}>
          {placeholder}
        </label>
        <div className="radio-group">
          {options.map(option => this.renderBoxes(inputProps, option))}
        </div>
      </div>
    );
  };

  renderBoxes(inputProps, options) {
    return (
      <div className="radio-option-wrap" key={options.value}>
        <div className="radio-option">
          <input
            className="radio-option-input"
            name={inputProps.name}
            id={`${inputProps.name}_${options.value}`}
            value={options.value}
            {...inputProps}
            checked={options.value === this.props.value}
          />
          <span className="radio-option-mark" />
          <label
            className="radio-option-label"
            htmlFor={`${inputProps.name}_${options.value}`}
          >
            <span className="radio-option-copy">{options.label}</span>
          </label>
        </div>
        {options.child ? options.child : ''}
      </div>
    );
  }

  handleChange = e => {
    if ('onChange' in this.props) this.props.onChange(e);
    if ('setValue' in this.props)
      this.props.setValue(
        e.currentTarget[this.props.type === 'checkbox' ? 'checked' : 'value']
      );
  };
}

export default withFormsy(Radio);



// WEBPACK FOOTER //
// ./src/components/form/Radio.js